import { combineReducers } from 'redux';

import { REQUEST_GOOGLE_PAY, SUCCESS_GOOGLE_PAY, FAILURE_GOOGLE_PAY } from './constants';

const widgetLink = (state = null, action) => {
    switch (action.type) {
        case SUCCESS_GOOGLE_PAY:
            return action.response.payload.widgetLink;
        case REQUEST_GOOGLE_PAY:
        case FAILURE_GOOGLE_PAY:
            return null;
        default:
            return state;
    }
};

const fetchingGooglePay = (state = false, action) => {
    switch (action.type) {
        case REQUEST_GOOGLE_PAY:
            return true;
        case FAILURE_GOOGLE_PAY:
        case SUCCESS_GOOGLE_PAY:
            return false;
        default:
            return state;
    }
};

const errorGooglePay = (state = '', action) => {
    switch (action.type) {
        case FAILURE_GOOGLE_PAY:
            return action.response.message;
        case REQUEST_GOOGLE_PAY:
        case SUCCESS_GOOGLE_PAY:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    widgetLink,
    fetchingGooglePay,
    errorGooglePay
});



// WEBPACK FOOTER //
// ./src/services/googlepay/reducer.js